module.exports = __webpack_public_path__ + "img/old.54f5bf33.png";